import { z } from 'zod'

export const assignTagsToDeviceSchema = z.object({
  nameTags: z.array(z.string()),
})

export type TAssignTagsToDeviceFields = z.infer<typeof assignTagsToDeviceSchema>
